import { Component, OnInit, OnDestroy } from '@angular/core';
import {ShareModule} from '../../../share/share.module';

@Component({
    selector: 'app-profile-audit-audience-demo',
    templateUrl: './profile-audit-audience-demo.component.html',
    styleUrl: './profile-audit-audience-demo.component.scss',
    standalone: false
})
export class ProfileAuditAudienceDemoComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit(): void {
    // Pusto
  }

  ngOnDestroy(): void {
    // Pusto
  }

}
